import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPrestacionCUMEByID = {
  status: number | null;
  statusText: string | null;
};

const useGetPrestacionCUMEByID = () => {
  const [loadingGetPrestacionCUMEByID, setLoadingPrestacionCUMEByID] = useState(false);
  const [successGetPrestacionCUMEByID, setSuccessPrestacionCUMEByID] = useState(false);
  const [errorGetPrestacionCUMEByID, setErrorPrestacionCUMEByID] = useState<any>(null);
  const [dataGetPrestacionCUMEByID, setDataPrestacionCUME] = useState<any>(null);

  const [statusGetPrestacionCUMEByID, setStatusGetPrestacionCUMEByID] =
    useState<StatusGetPrestacionCUMEByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getPrestacionCUMEByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingPrestacionCUMEByID(true);
    setSuccessPrestacionCUMEByID(false);
    setErrorPrestacionCUMEByID(null);

    try {
      const res = await apiRecord.getPrestacionEconomicaCUMEByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetPrestacionCUMEByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessPrestacionCUMEByID(true);
      setDataPrestacionCUME(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetPrestacionCUMEByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorPrestacionCUMEByID(err);
      console.error("Error en getPrestacionCUMEByID:", err);

      throw err;

    } finally {
      setLoadingPrestacionCUMEByID(false);
    }
  };

  return {
    getPrestacionCUMEByID,
    loadingGetPrestacionCUMEByID,
    successGetPrestacionCUMEByID,
    errorGetPrestacionCUMEByID,
    dataGetPrestacionCUMEByID,
    statusGetPrestacionCUMEByID
  };
};

export default useGetPrestacionCUMEByID;
